import clsx from 'clsx'
import React, { ReactElement } from 'react'
import { Controller } from 'react-hook-form'

import styles from './styles.module.scss'

export interface IControllerMultiSwitchFieldProps<T> {
  control: any
  rules: any
  name: any
  options: { label: string; value: T }[]
  defaultValue: T
  message?: string
  label?: string | ReactElement
  placeholder?: string
  ref?: any
  inline?: boolean
  active?: any
  inactive?: any
  disabled?: boolean
  containerClassName?: string
  optionClassName?: string
}

export default function ControlledMultiSwitchField<T>({
  control,
  rules,
  name,
  message,
  label,
  ref,
  options,
  defaultValue,
  inline = false,
  disabled = false,
  containerClassName,
  optionClassName,
}: IControllerMultiSwitchFieldProps<T>) {
  return (
    <div
      className={`${styles.field} ${inline ? styles.inline : ''} ${containerClassName ? containerClassName : ''}`}
    >
      <div className={styles.title}>{label}</div>
      <Controller
        control={control}
        rules={rules}
        render={({ field, formState: { errors } }) => (
          <div className={styles.containerSwitch}>
            {options.map((option, index) => {
              return (
                <div
                  key={option.label}
                  className={clsx(
                    styles.option,
                    {
                      [styles.checked]:
                        field.value === option.value ||
                        (field.value === undefined &&
                          defaultValue === option.value),
                    },
                    { [styles.disable]: disabled },
                    {
                      [styles.removeRightBorder]:
                        field.value !== option.value &&
                        index < options.length - 1 &&
                        field.value === options[index + 1].value,
                    },
                    {
                      [styles.removeLeftBorder]:
                        field.value !== option.value &&
                        index > 0 &&
                        field.value === options[index - 1].value,
                    },
                    { [optionClassName ?? '']: optionClassName !== undefined },
                  )}
                  onClick={() => {
                    !disabled && field.onChange(option.value)
                  }}
                  ref={ref}
                >
                  {option.label}
                </div>
              )
            })}
            {errors[name] && (
              <span className='form__error'>
                {errors[name]?.message?.toString() || 'Erreur'}
              </span>
            )}
          </div>
        )}
        name={name}
      />

      {message && <span color='red'>{message}</span>}
    </div>
  )
}
